





































































































import { Component, Prop } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import Order from "@/store/entities/booking/order";
import moment from "moment";

class PostData {
  supplierId: number | null = 0;
  orderId: number = 0;
}

@Component({
  components: {},
})
export default class SeletedPayee extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: 0 })
  orderId: number;
  order: Order;
  postData = new PostData();
  tabName: string = "supplierId";
  phoneNumber: string = "";
  offers: any = [];
  courtList: any = [];
  orderContent: string = "";
  supplierList: Array<any> = [];

  regex = /(\S+),\s*(\d{4}-\d{2}-\d{2}),\s*(\d{1,2}:\d{2}),\s*(\d+)位:\s*(.+)/;

  async onlineToOffline() {
    this.postData.orderId = this.orderId;
    // 调用dispatch时传递两个参数：id和supplierId
    await this.$store.dispatch({
      type: "order/onlineToOffline",
      id: this.orderId,
      supplierId: this.postData.supplierId,
    });

    this.$Message.success({
      content: "转到线下订单成功",
    });
    this.closeTable();
    return;
    (this.$refs.postDataForm as any).validate(async (valid: boolean) => {
      console.log(valid, "valid");
      if (valid) {
        this.postData.orderId = this.orderId;
        // 调用dispatch时传递两个参数：id和supplierId
        await this.$store.dispatch({
          type: "order/onlineToOffline",
          id: this.orderId,
          supplierId: this.postData.supplierId,
        });

        this.$Message.success({
          content: "转到线下订单成功",
        });
        this.closeTable();
      }
    });
  }
  getTime(value) {
    return Util.int2time(value);
  }

  cancel() {
    this.$emit("input", false);
  }

  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }

  // checkSupplierId(rule: any, value: any, callback: any) {
  //   if (!this.postData.supplierId) {
  //     callback(new Error("请选择收款方"));
  //   } else {
  //     callback();
  //   }
  // }

  get orderTypeList() {
    return this.$store.state.common.orderTypes;
  }

  /**
   * @description:表单校验规则
   */
  postDataRule = {};

  /**
   * @description:弹窗发生改变事件
   */
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.postData = new PostData();
      this.$emit("getPage");
    } else {
      this.getSupplierList();
    }
  }
  /**
   * @description:获取供应商列表
   */
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
}
